import { NgModule, Provider, SchemaMetadata, Type } from '@angular/core';
import { MetadataOverride } from '@angular/core/testing';

import { merge } from '../internals/merge';
import { mockProvider, MockProvider } from '../mock';
import { OptionalsRequired } from '../types';

/**
 * @internal
 */
export interface BaseSpecOptions {
  disableAnimations?: boolean;
  entryComponents?: Type<any>[];
  mocks?: Type<any>[];
  mockProvider?: MockProvider;
  providers?: any[];
  declarations?: any[];
  imports?: any[];
  schemas?: (SchemaMetadata | any[])[];
  overrideModules?: [Type<any>, MetadataOverride<NgModule>][];
}

/**
 * @internal
 */
export interface BaseSpecOverrides {
  providers?: Provider[];
}

const defaultOptions: OptionalsRequired<BaseSpecOptions> = {
  disableAnimations: true,
  entryComponents: [],
  mocks: [],
  mockProvider,
  providers: [],
  declarations: [],
  imports: [],
  schemas: [],
  overrideModules: []
};

/**
 * @internal
 */
export function getDefaultBaseOptions(options?: BaseSpecOptions): Required<BaseSpecOptions> {
  return merge<BaseSpecOptions>(defaultOptions, options);
}
